export default {
  SET_CONFIGURATION: function(state, payload) {
    state.configurations = payload;
    state.is_configurator_fetched = true;
  },
  SET_CONFIGURATOR: function(state, payload) {
    const selected_configurator = state.configurations.find(
      item => item.slug === payload.type
    );

    function get_all_combinations(id, haystack) {
      let result = [];
      for (let i = 0; i < haystack.length; i++) {
        result.push(id + haystack[i].material_id);
      }
      return result;
    }

    if (payload.base) {
      const combination = payload.base.match(/\d{1,3}\D{1}/g);
      let is_truth = true;
      combination.forEach(combi => {
        const id = combi.match(/\D{1}/g)[0];
        const original_id = combi.match(/\d{1,2}/g)[0];
        const index = parseInt(original_id) - 1;

        if (
          !get_all_combinations(
            original_id,
            selected_configurator.configs[index].material
          ).includes(combi)
        ) {
          is_truth = false;
          return;
        }

        selected_configurator.configs[index].material.map(mat => {
          mat.active = mat.material_id === id ? true : false;
          return mat;
        });
      });
      if (!is_truth) {
        alert('One of the combinations is incorrect. Please check your link.');
      }
    }

    setTimeout(() => {
      if (state.configurator.slug === 'bathroom') {
        if (state.configurator.configs[6].material[0].active) {
          state.configurator.configs[7].material[2].isDisabled = false;
        } else {
          state.configurator.configs[7].material[2].isDisabled = true;
        }
      }
    }, 1000);

    if (payload.overlay) {
      const combination = payload.overlay.match(/\d{1,3}\D{1}/g);
      let is_truth = true;
      combination.forEach(combi => {
        const id = combi.match(/\D{1}/g)[0];
        const original_id = combi.match(/\d{1,2}/g)[0];
        const index = parseInt(original_id) - 1;

        if (
          !get_all_combinations(
            original_id,
            selected_configurator.configs[index].material
          ).includes(combi)
        ) {
          is_truth = false;
          return;
        }

        selected_configurator.configs[index].material.map(mat => {
          mat.active = mat.material_id === id ? true : false;
          return mat;
        });
      });
      if (!is_truth) {
        alert('One of the combinations is incorrect. Please check your link.');
      }
    }

    if (typeof selected_configurator !== 'undefined') {
      state.configurator = selected_configurator;
      state.configurator_overlay = selected_configurator.has_overlay;
      state.is_configurator_selected = true;
      state.is_configurator_undefined = false;
    } else {
      state.configurator = undefined;
      state.is_configurator_undefined = true;
    }
  },
  SET_TYPE: function(state, payload) {
    state.type = payload;
  },
  SET_SOCIAL: function(state, payload) {
    state.social = payload;
    state.social_title = payload.title;
  },
  SET_ACTIVE: function(state, payload) {
    state.configurator.configs = state.configurator.configs.map(item => {
      return {
        ...item,
        active: item.id === payload,
      };
    });
  },
  SET_APP_PRELOADED: function(state, payload) {
    if (state.configurator.preloaded) return false;
    state.app_preloaded = payload;
    state.configurator.preloaded = payload;
  },
  CHANGE_COMBINATION: function(state, payload) {
    const id = parseInt(payload.id);
    const index = state.configurator.configs.findIndex(config => {
      return parseInt(config.id) === id;
    });

    if (state.configurator.slug === 'bathroom') {
      if (id === 7 && payload.material_id == 'A') {
        state.configurator.configs[7].material[2].isDisabled = false;
        state.configurator.configs[7].material[0].active = true;
        state.configurator.configs[7].material[2].active = false;
      } else {
        state.configurator.configs[7].material[2].isDisabled = true;
      }
    }

    state.configurator.configs[index].material.map(mat => {
      mat.active = mat.material_id === payload.material_id ? true : false;
      return mat;
    });
  },
  ADD_OVERLAY_ITEM: function(state, payload) {
    const moverlay_id = parseInt(payload.id);
    const index = state.configurator.configs.findIndex(config => {
      return parseInt(config.id) === moverlay_id;
    });
    const matIndex = state.configurator.configs[index].material.findIndex(
      mat => {
        return mat.material_id === payload.material_id;
      }
    );

    state.configurator.configs[index].material = state.configurator.configs[
      index
    ].material.map(mat => {
      let accessories_arr = state.configurator.configs[index].material.filter(
        mat => mat.active
      );

      if (matIndex === 0) {
        mat.active = true;

        if (mat.name !== 'None') {
          mat.active = false;
        }
      } else if (mat.name === 'None') {
        mat.active = false;
        state.configurator.configs[index].material[matIndex].active = !state
          .configurator.configs[index].material[matIndex].active;
      } else if (accessories_arr.length === 0) {
        state.configurator.configs[index].material[0].active = true;
      }
      return mat;
    });
  },
  SET_SOCIAL_URL: function(state, payload) {
    state.social.url = payload;
  },
};
